<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="80%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="专辑" prop="category_id">
        <el-select v-model="formData.category_id" placeholder="请选择专辑" filterable>
          <el-option :key="0" label="请选择专辑" :value="formData.category_id"></el-option>
          <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间" prop="on_time">
        <el-date-picker
          v-model="formData.on_time"
          type="datetime"
          value-format="timestamp"
          @focus="initOnTime"
          placeholder="选择时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="排序值" prop="sort_num">
        <el-input-number v-model="formData.sort_num" :min="0" :max="65535"></el-input-number>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="formData.status" placeholder="请选择专辑" filterable>
          <el-option :key="1" label="上架" :value="1"></el-option>
          <el-option :key="2" label="下架" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <quill-editor ref="quillEditorRef" v-model="formData.content" :options="editorOption" />
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ header: 1 }, { header: 2 }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ size: ['small', false, 'large', 'huge'] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['sourceEditor']
]

export default {
  name: 'handpick_article_add',
  props: [
    'visible', 'id'
  ],
  components: {
    'quill-editor': quillEditor
  },
  data () {
    return {
      title: '添加文章',
      formData: {
        source_id: 0,
        category_id: 0,
        content: '',
        on_time: 0,
        sort_num: 0,
        status: 1
      },
      categoryList: [],
      addFormRules: {
        category_id: [
          { required: true, message: '专辑不能为空', trigger: 'blur' }
        ]
      },
      editorOption: {
        placeholder: '编辑配置内容',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image (value) {
                if (value) {
                  document.querySelector('#quill_upload').click()
                }
              },
              video (value) {
                if (value) {
                  document.querySelector('#quill_upload_media').click()
                }
              }
            }
          },
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        }
      },
      uploadPrepareResp: {}
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.formData.on_time = this.formData.on_time / 1000
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑文章'
        this.getArticleInfo(this.id)
      }
    },
    async getArticleInfo (id) {
      const res = await this.$http.get('/admin/handpick_article/info/' + id)
      if (res.code === 0) {
        this.formData = {
          source_id: res.data.source_id,
          category_id: res.data.category_id,
          content: res.data.content,
          on_time: res.data.on_time * 1000,
          sort_num: res.data.sort_num,
          status: res.data.status
        }
        this.getCategoryList()
      }
    },
    initOnTime () {
      if (this.formData.on_time === 0) {
        this.formData.on_time = new Date(new Date().toLocaleDateString()).getTime()
      }
    },
    async getCategoryList () {
      const res = await this.$http.get('/admin/handpick_category/select_list', {
        // source_id: this.formData.source_id
        source_id: 0
      })
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async uplodPrepare (fileName) {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    handleQuillSuccess (res) {
      // 获取富文本组件实例
      const quill = this.$refs.quillEditorRef.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        const length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.data.url)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        console.log('图片插入失败')
      }
    },
    handleMediaQuillUpload (file) {
      const fileNameArr = file.name.split('.')
      const key = 'media/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: false, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = true
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        const pointIndex = res.key.lastIndexOf('.')
        const fileType = res.key.substring(pointIndex + 1)
        const mediaUrl = this.uploadPrepareResp.res_domain + res.key
        if (fileType === 'mp3' || fileType === 'ogg' || fileType === 'm4a') {
          this.insertAudio(mediaUrl)
        } else {
          this.insertVideo(mediaUrl)
        }
        this.uploading = false
        this.upPercent = 0
      }
      observable.subscribe({ next, error, complete })
      return false
    },
    insertAudio (url) {
      const quill = this.$refs.quillEditorRef.quill
      const length = quill.getSelection().index
      quill.insertEmbed(length, 'audio', { url: url }, 'api')
      quill.setSelection(length + 1)
    },
    insertVideo (url) {
      const quill = this.$refs.quillEditorRef.quill
      const length = quill.getSelection().index
      quill.insertEmbed(length, 'video', url)
      quill.setSelection(length + 1)
    }
  }
}
</script>

<style scoped>
</style>
